import { Button, Container, CssBaseline, Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import React from 'react';
import { ProgressData, ProgressDataType } from './Paperbase';
import { OperationLogs } from './OperationLogs';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import { Operations } from './NavigatorData';
import { ResultFileState } from './ConfigFormData';

const useStyles = makeStyles({
    button: {
        margin: '5px 5px'
      },
  });

export function currentTime() {
    let today = new Date();
    let date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
    let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    let dateTime = date+' '+time;
    return dateTime;
}

export interface LogContentProps {
    onClearAllLog :() => void;
    onClearOperationLog :(operation: Operations) => void;
    allProgressData: ProgressDataType;
    resultFileState : ResultFileState;
}

function LogContent(props: LogContentProps) {
    const {onClearAllLog, onClearOperationLog, allProgressData, resultFileState} = props;
    // console.log('anyLogsHaveItems', anyLogsHaveItems(allProgressData));
    const classes = useStyles();

    let LogContent: JSX.Element;
    if(anyLogsHaveItems(allProgressData)) {
            LogContent =  <Grid>
                            <Grid>
                                <Button variant="contained" className={classes.button}
                                        color="primary" onClick={onClearAllLog} endIcon={<ClearAllIcon />}>
                                    Clear All
                                </Button>
                            </Grid>
                            <Paper>
                                <div style={{ overflowY: 'auto', maxHeight: '80vh'}}>
                                    <OperationLogs operation={Operations.compare} logs={allProgressData[Operations.compare].logs} percentage={allProgressData[Operations.compare].percentage} resultFileState={resultFileState} onClearLog={() => onClearOperationLog(Operations.compare)}/>
                                    <OperationLogs operation={Operations.twoWayMerge} logs={allProgressData[Operations.twoWayMerge].logs} percentage={allProgressData[Operations.twoWayMerge].percentage} resultFileState={resultFileState} onClearLog={() => onClearOperationLog(Operations.twoWayMerge)}/>
                                    <OperationLogs operation={Operations.threeWayMerge} logs={allProgressData[Operations.threeWayMerge].logs} percentage={0} resultFileState={resultFileState} onClearLog={() => onClearOperationLog(Operations.threeWayMerge)}/>
                                    <OperationLogs operation={Operations.graft} logs={allProgressData[Operations.graft].logs} percentage={0} resultFileState={resultFileState} onClearLog={() => onClearOperationLog(Operations.graft)}/>
                                    <OperationLogs operation={Operations.patch} logs={allProgressData[Operations.patch].logs} percentage={allProgressData[Operations.patch].percentage} resultFileState={resultFileState} onClearLog={() => onClearOperationLog(Operations.patch)}/>
                                </div>
                            </Paper>
                          </Grid>
        } else {
            LogContent = <React.Fragment>
                            <CssBaseline />
                            {/* Hero unit */}
                            <Container maxWidth="sm" component="main">
                                <Typography variant="body1" align="center" color="primary">
                                    No Logs Available
                                </Typography>
                            </Container>
                            {/* End hero unit */}
                         </React.Fragment>
        } 
    
    return (
        <div>
            { LogContent }
        </div> 
    );
}

function anyLogsHaveItems(allProgressData: ProgressDataType) {
    const itemWithLogEntries = Object.entries(allProgressData).find((keyValuePair) => {
        const [key, value] = keyValuePair;
        const progressData: ProgressData = value;
        return progressData.logs.length > 0
    });
    return !!itemWithLogEntries;
}

export default LogContent;